<template>
    <div>
        <div id="iconModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">Select Icon</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">

                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab"
                                   aria-controls="home" aria-selected="true">View All</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab"
                                   aria-controls="profile" aria-selected="false">Search</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="contact-tab" data-bs-toggle="tab" href="#contact" role="tab"
                                   aria-controls="contact" aria-selected="false">Ionicons</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div class="row">
                                    <div class="col-3">
                                        <div class="list-group">
                                            <a v-for="category in categories" href="javascript:void(0)"
                                               @click="onCategoryClick(category)"
                                               class="list-group-item list-group-item-action size-sm"
                                               :class="selectedCategory === category ? 'active' : '' ">
                                                {{category}}
                                            </a>
                                        </div>
                                    </div>

                                    <div class="col-9">
                                        <div class="d-flex flex-wrap">
                                            <div v-for="icon in iconList" class="m-1">
                                                <div @click="onIconSelected(icon)">
                                                    <i :class="getIconClasses(icon)" class="fa-2x"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                                <div class="mt-3">Icon search</div>
<!--                                <typeahead v-model="iconSearch" :data="model.icons">-->
<!--                                    &lt;!&ndash; Begin custom suggestion slot &ndash;&gt;-->
<!--                                    <template slot="suggestion" slot-scope="{ data, htmlText }">-->
<!--                                        <div class="d-flex align-items-center">-->
<!--                                            <i :class="getIconClass(data)" class="fa-2x"></i>-->
<!--                                            <span class="ms-4" v-html="htmlText"></span>-->
<!--                                        </div>-->
<!--                                    </template>-->
<!--                                </typeahead>-->

                                <vue3-simple-typeahead
                                        id="typeahead_id"
                                        placeholder="Icon Search"
                                        :items="availableIcons"
                                        :minInputLength="1"
                                        @selectItem="onIconSelectedSearch">
                                    <template #list-item-text="slot">
                                        <div class="d-flex align-items-center">
                                            <i :class="getIconClass(slot.item)" class="fa-2x"></i>
                                            <span class="ms-4" v-html="slot.boldMatchText(slot.itemProjection(slot.item))"></span>
                                        </div>

                                        <span v-html="slot.boldMatchText(slot.itemProjection(slot.item))"></span>
                                    </template>
                                </vue3-simple-typeahead>


                            </div>

                            <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                <ionicons></ionicons>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Ok</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import UIUtil from "../../utils/UIUtil";
    import Ionicons from "../../components/Ionicons.vue";

    export default {
        name: 'IconModal',
        components: {Ionicons},
        props: {
            yesEvent: Function
        },
        computed: {
            availableIcons() {
                return Object.values(this.model.icons)
            }
        },
        data() {
            return {
                model: webase.model,
                iconSearch: '',
                uiUtil: new UIUtil(),
                categories: ['regular', 'solid', 'brands'],
                selectedCategory: '',
                iconList: [],
                selectedIcon: null,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('iconModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)
            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
            this.currentModal.show()
            this.onCategoryClick('solid')
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"

                let dashIndex = this.iconSearch.indexOf('-')

                if (this.selectedIcon) {
                    let iconData = {
                        type: 'fa',
                        style: this.uiUtil.getIconTypeClass(this.selectedCategory),
                        icon: this.selectedIcon
                    }

                    this.yesEvent(iconData)
                } else if (dashIndex > 0) {
                    let iconType = this.iconSearch.substring(0, dashIndex)

                    let iconData = {
                        type: 'fa',
                        style: this.uiUtil.getIconTypeClass(iconType),
                        icon: this.iconSearch.substring(dashIndex + 1)
                    }

                    this.yesEvent(iconData)
                }

                // hide the modal
                this.noHandler()
            },
            getIconClass(data) {
                console.log('getIconClass')
                console.log(data)
                let dashIndex = data.indexOf('-')
                let iconType = data.substring(0, dashIndex)
                let iconStyle = data.substring(dashIndex + 1)
                let iconClasses = this.uiUtil.getIconTypeClass(iconType) + ' fa-' + iconStyle
                return iconClasses
            },

            getIconClasses(icon) {
                // let dashIndex = data.indexOf('-')
                // let iconType = data.substring(0, dashIndex)
                // let iconStyle = data.substring(dashIndex + 1)
                let colorClass = icon === this.selectedIcon ? 'text-primary' : 'text-dark'
                let iconClasses = this.uiUtil.getIconTypeClass(this.selectedCategory) + ' fa-' + icon + ' ' + colorClass
                return iconClasses
            },

            onCategoryClick(category) {
                this.selectedCategory = category
                this.iconList = this.model.iconsByCategory[category]
            },

            onIconSelected(icon) {
                this.selectedIcon = icon
                console.log('Selected Icon')
                console.log(this.selectedCategory)
                console.log(icon)
            },
            onIconSelectedSearch(item) {
                console.log('Selected Icon in Search')
                console.log(item)
                this.iconSearch = item
            },
            // iconProjectionFunction(item) {
            //     console.log('iconProjectionFunction')
            //     console.log(item)
            // }

        }
    }
</script>
